export const FormatirajDatum = {
  methods: {
    DolociIzbranMesec (prenosniParameter) {
      let izbranoObdobje = {}
      let trajanjeOd = new Date(prenosniParameter)
      let trajanjeDo = null
      if (trajanjeOd.getMonth() <= 10) {
        trajanjeDo = new Date(trajanjeOd.getFullYear(), trajanjeOd.getMonth() + 1, 1)
      } else {
        trajanjeDo = new Date(trajanjeOd.getFullYear() + 1, 0, 1)
      }
      let dan = trajanjeOd.getDate()
      let mesec = trajanjeOd.getMonth() + 1
      if (dan < 10) {
        dan = '0' + dan
      }
      if (mesec < 10) {
        mesec = '0' + mesec
      }
      izbranoObdobje.trajanjeOd = trajanjeOd.getFullYear() + '-' + mesec + '-' + dan
      mesec = trajanjeDo.getMonth() + 1
      if (mesec < 10) {
        mesec = '0' + mesec
      }
      izbranoObdobje.trajanjeDo = trajanjeDo.getFullYear() + '-' + mesec + '-' + '01'
      return izbranoObdobje
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatirajDatum.js